import React from 'react';
import InputLabel from '../common/InputLabel';
import FormRow from './FormRow';
import { getTotal } from './utils';
import OutputLabel from '../common/OutputLabel';

const TotalRow = ({ formData = [], label = '', currency }) => {
    const totals = getTotal(formData);
    const outputValue1 = !Number.isNaN(totals.cost) ? totals.cost.toFixed(2) : 0;
    const outputString1 = `${currency}${outputValue1}`;
    const outputValue2 = !Number.isNaN(totals.cpor) ? totals.cpor.toFixed(2) : 0;
    const outputString2 = `${currency}${outputValue2}`;
    return (
        <FormRow className="occCost-total-row">
            <InputLabel text={`${label} Total`} style={{ fontWeight: 'bold' }} />
            <OutputLabel placeholder="0" text={outputString1} />
            <OutputLabel placeholder="0" text={outputString2} />
        </FormRow>
    );
};

export default TotalRow;
